import { Theme, useMediaQuery } from '@mui/material';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  IReceiptKindTravelCostPickerProps,
  ReceiptKindTravelCostPicker,
} from '@work4all/components/lib/components/entity-picker/receipt-kind-travel-cost-picker/ReceiptKindTravelCostPicker';

import { reactRefSetter } from '@work4all/utils';

import { LabeledInput } from '../../containers/mask-overlays/locked-inputs';

interface ReceiptKindTravelCostPickerFieldProps
  extends Omit<IReceiptKindTravelCostPickerProps<false>, 'multiple'> {
  error?: string;
  name?: string;
  label?: string;
  disabled?: boolean;
}

export const ReceiptKindTravelCostPickerField = React.forwardRef<
  HTMLDivElement,
  ReceiptKindTravelCostPickerFieldProps
>(function VatPickerField(props, ref) {
  const { error, label, disabled, ...pickerProps } = props;

  const { t } = useTranslation();

  const wrapperRef = useRef<HTMLDivElement>(null);
  const popoverRef = useRef<EntityPickerPopover>(null);
  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );

  return (
    <div ref={reactRefSetter(wrapperRef, ref)}>
      <EntityPickerPopover
        fullscreen={isMobile}
        ref={popoverRef}
        anchorEl={wrapperRef}
        disabled={disabled}
        picker={
          <ReceiptKindTravelCostPicker
            {...pickerProps}
            clearable={false}
            multiple={false}
          />
        }
      >
        <LabeledInput
          value={props.value?.name}
          name={props.name}
          disabled={disabled}
          label={label ?? t('COMMON.RECEIPT_KIND_TRAVEL_COSTS')}
          error={error}
        />
      </EntityPickerPopover>
    </div>
  );
});
